/** @format */

const HelpTranslations = {
  en: {
    'Help.label': 'WOULD YOU LIKE TO KNOW MORE?',
    'Help.titolo': 'Need ',
    'Help.titoloBold': 'help?',
    'Help.sottotitoloBold': 'WeMi ',
    'Help.sottotitolo':
      'WeMi provides several channels for more information. Use the channel you prefer among those here to follow.',
    'Help.titolo.icona': 'Write to us',
    'Help.sottotitolo.icona': 'Send an ',
    'Help.sottotitoloBold.icona': 'e-mail ',
    'Help.sottotitolo1.icona': 'using our contact form',
    'Help.titolo.icona1': 'Call',
    'Help.sottotitolo.icona1': 'Contact our toll-free number:',
    'Help.sottotitoloNumero.icona1': ' 800 123 456',
    'Help.titolo.icona2': 'Learn More',
    'Help.sottotitolo.icona2': 'Consult the ',
    'Help.sottotitoloBold.icona2': ' FAQ ',
    'Help.sottotitolo1.icona2': ' you may already find your answer',
  },
  it: {
    'Help.label': 'Vuoi saperne di più?',
    'Help.titolo': 'Serve ',
    'Help.titoloBold': ' aiuto?',
    'Help.sottotitoloBold': 'WeMi ',
    'Help.sottotitolo':
      'WeMi mette a disposizione diversi canali per avere maggiori informazioni. Utilizza il canale che preferisci tra quelli qui a seguire.',
    'Help.titolo.icona': 'Scrivici',
    'Help.sottotitolo.icona': 'Invia un',
    'Help.sottotitoloBold.icona': 'e-mail ',
    'Help.sottotitolo1.icona': 'utilizzando il modulo di contatto',
    'Help.titolo.icona1': 'Chiamaci',
    'Help.sottotitolo.icona1': 'Contatta il nostro numero verde:',
    'Help.sottotitoloNumero.icona1': ' 800 123 456',
    'Help.titolo.icona2': 'Approfondisci',
    'Help.sottotitolo.icona2': 'Consulta le ',
    'Help.sottotitoloBold.icona2': ' FAQ ',
    'Help.sottotitolo1.icona2': ' potresti già trovare la tua risposta',
  },
};

export default HelpTranslations;
